





































































import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import IconButton from "@/components/IconButton.vue";
import eventBus from "@/services/eventBus";

import store, { ObjectMarkStore } from "../services/ObjectMarkStore";
import GeneralObjectMarkTag from "../models/GeneralObjectMarkTag";

interface Data {
  store: ObjectMarkStore;
}

interface Methods {
  updateItem(item: GeneralObjectMarkTag): void;
}

interface Computed {
  columns: ApiSearchColumn[];
  url: string;
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
      ApiSearchPage,
      IconButton
  },

  data() {
    return {
      store,
      loading: false,
    };
  },

  methods: {
    updateItem(item) {
      item.selected = false;
      item.deleted = !item.deleted;
      store.updateObjectMarkTag(item).then(r => eventBus.$emit('refreshObjectMarks'));
    },
  },

  computed: {
    url() {
      return `object-mark/tags/search`;
    },
    columns: function() {
      return [
        {
          field: "id",
          title: "",
          cell: 'command',
          filterable: false,
          sortable: false,
          width: 50,
        },
        {
          field: "deleted",
          title: "Aktív",
          cell: "deleted",
          filterable: false,
          sortable: false,
          width: 50,
        },
        {
          field: "remark",
          title: "Címke megnevezése",
          cell: "remark",
        },
      ];
    },
  }
});
